/* unplugin-vue-components disabled */import script from "./select-location-view.vue?vue&type=script&setup=true&lang=js"
export * from "./select-location-view.vue?vue&type=script&setup=true&lang=js"

import "./select-location-view.vue?vue&type=style&index=0&id=64ab98ca&lang=scss&scoped=true"
import "./select-location-view.vue?vue&type=style&index=1&id=64ab98ca&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\work\\space-0\\fsplus-vue-workspace\\foshan-street\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64ab98ca"]])

export default __exports__